import { createElement } from '@max/max';
import View from '@hfe/max-view';
import Price from '@max/leez-price';
import Text from '@max/leez-text';
import ExpiredTime from '../expired-time';
import Button from '../button';
import InflateLogo from '../inflate-logo';
import { getDescText, getPriceText } from '../../utils/coupon';
import './index.scss';
import '../../common.scss';
export default function OneColCoupon(props) {
    const { formatCouponConfigRes, couponData, amountColor, currentTimeMillis, toastConfig, updateCouponList, index, setCurrentTimeMillis, location, isShowContainer, bizLine, hotelchannel } = props || {};
    const { title = '', beginTime, status } = couponData || {};
    const inlineStyle = {
        expiredTimeStyle: {
            marginTop: '12rpx',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start'
        },
        containerStyle: {
            width: isShowContainer ? '678rpx' : '702rpx'
        }
    };
    return <View className="one-col-container" style={inlineStyle.containerStyle}>
      <InflateLogo type="one" status={status}/>
      <View className="one-col-left">
        <View className="one-col-left-content">
          <Price content={getPriceText(couponData)} type="l1" showSymbol crossed={false} smallDecimal={true} fontWeightType="bold" color={amountColor}/>
          <Text style={{
            height: '28rpx'
        }} className="one-col-desc" text={getDescText(couponData)} type="label2" color={amountColor} lineClamp={1}></Text>
        </View>
      </View>
      <View className="one-col-middle">
        <Text text={title.slice(0, 9)} type="title3" lineClamp={1}/>
        <ExpiredTime location={location} updateCouponList={updateCouponList} formatCouponConfigRes={formatCouponConfigRes} couponData={couponData} currentTimeMillis={currentTimeMillis} containerStyle={inlineStyle.expiredTimeStyle} setCurrentTimeMillis={setCurrentTimeMillis}/>
      </View>
      <View className="one-col-right">
        <View style={{
            backgroundColor: '#FFF'
        }}>
          <Button location={location} formatCouponConfigRes={formatCouponConfigRes} index={index} updateCouponList={updateCouponList} toastConfig={toastConfig} currentTimeMillis={currentTimeMillis} setCurrentTimeMillis={setCurrentTimeMillis} beginTime={beginTime} couponData={couponData} size={'big'} amountColor={amountColor} bizLine={bizLine} hotelchannel={hotelchannel}/>
        </View>
      </View>
    </View>;
}
